// Error.js

import { Link } from "react-router-dom";
import errorPage from "../../../assets/extras/404-page.png";

const Error = () => {
    return (
        <main className="secondary-page__content">
            <div className="wrapper wrapper-secondary">
                <div className="content-container">
                    <div className="error-page">
                        <div className="error-page__image">
                            <img src={errorPage} alt="404 error"></img>
                        </div>

                        <Link to="/"><button className="error-page__button primary-button">Go to Home</button></Link>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default Error;